import React from 'react';
import { Viewport } from 'src/components/Viewport';
import { getApplicationProperty } from 'src/helpers/applicationProperty';
import { useStyles } from 'src/components/ApartmentPageV2/ApartmentDescription/styles';
import { IViewConfig } from 'src/typings/viewConfig';
import {
  ReactImageGalleryItemWithSpinnerData,
} from 'src/components/ApartmentPageV2/ApartmentGallery/types';
import {
  ApartmentDescriptionTour,
} from 'src/components/ApartmentPageV2/ApartmentDescription/components/ApartmentDescriptionTour';
import { useAppMediaQuery } from 'src/hooks/app/useAppMediaQuery';

interface Props {
  viewConfig: IViewConfig,
  iframeData: ReactImageGalleryItemWithSpinnerData[]
  title?: string;
  useCover?: boolean;
}

export const ApartmentDescriptionTourWrapper: React.FC<Props> = ({
  viewConfig, iframeData, title, useCover,
}) => {
  const styles = useStyles({});
  const { isMdDown } = useAppMediaQuery();
  return (
    <>
      { isMdDown && (
        <Viewport render={(render: { visible: boolean }) => {
          if (!render.visible) {
            return (
              <></>
            );
          }
          return (
            <div className={`${useCover ? styles.ios : ''}`}>
              { iframeData.map((tour) => (
                <div key={tour.id} className={styles.frameWrapper}>
                  <div
                    className={`${styles.frameWrapperTitle} ${!useCover ? styles.frameWrapperTitlePadding : ''}`}
                  >
                    { title || getApplicationProperty(
                      viewConfig.applicationProperties,
                      tour.appProperty,
                    )?.translates?.[viewConfig?.lang] || tour.appProperty }
                  </div>
                  <ApartmentDescriptionTour tour={tour} useCover={useCover} />
                </div>
              )) }
            </div>
          );
        }}
        />
      ) }
    </>
  );
};
